import { initializeApp } from 'firebase/app';
import { GoogleAuthProvider, OAuthProvider, getAuth, signInWithPopup } from 'firebase/auth';
import { useEffect, useRef } from 'react';
import { AppService, AuthService } from '../services';
export function useSignIn({
  setLoading
} = {}) {
  const authRef = useRef(null);
  useEffect(() => {
    initFirebaseAuth();
  }, []);
  function initFirebaseAuth() {
    try {
      const app = initializeApp({
        apiKey: AppService.environment.firebase.apiKey,
        authDomain: 'geovelo-fr-geovelo.firebaseapp.com',
        projectId: 'geovelo.fr:geovelo'
      });
      authRef.current = getAuth(app);
    } catch (err) {
      console.error(err);
    }
  }
  function googleSignIn(locale, disableSignUp) {
    setLoading?.(true);
    return new Promise(async (resolve, reject) => {
      try {
        if (!authRef.current) throw new Error('Firebase not initialized');
        authRef.current.languageCode = locale;
        const provider = new GoogleAuthProvider();
        provider.setCustomParameters({
          prompt: 'select_account'
        });
        const result = await signInWithPopup(authRef.current, provider);
        const idToken = await result.user.getIdToken();
        const user = await AuthService.signInWithProvider('firebase', `Token ${idToken}`, true, locale, disableSignUp);
        resolve(user);
      } catch (err) {
        reject(err);
      }
      setLoading?.(false);
    });
  }
  function appleSignIn(locale, disableSignUp) {
    setLoading?.(true);
    return new Promise(async (resolve, reject) => {
      try {
        if (!authRef.current) throw new Error('Firebase not initialized');
        const provider = new OAuthProvider('apple.com');
        provider.addScope('email');
        provider.setCustomParameters({
          locale
        });
        const result = await signInWithPopup(authRef.current, provider);
        const idToken = await result.user.getIdToken();
        const user = await AuthService.signInWithProvider('firebase', `Token ${idToken}`, true, locale, disableSignUp);
        resolve(user);
      } catch (err) {
        reject(err);
      }
      setLoading?.(false);
    });
  }
  return {
    googleSignIn,
    appleSignIn
  };
}